import BackgroundImageLoader from './backgroundImageLoader';

export const imageLoader = new BackgroundImageLoader();

export function createBackgroundImageLoaderListeners (elements: NodeListOf<HTMLElement>): void {
    imageLoader.register(Array.from(elements));
}
